export default {
  online: {
    icon: "el-icon-success",
    desc: "Камера включена",
  },
  offline: {
    icon: "el-icon-warning",
    desc: "Камера отключена",
  },
  error: {
    icon: "el-icon-error",
    desc: "Проблема с потоком",
  },
  sleep: {
    icon: "el-icon-moon",
    desc: "В спящем режиме из-за длительного периода неактивности",
  },
  deleted: {
    icon: "el-icon-error",
    desc: "Камера удалена",
  }
};
